import React from 'react';
import { Link } from 'react-router-dom'
import { Badges, H4, H5, H6, Image, LI, UL } from '../../../AbstractElements'
import { Cart, Checkout, ViewCart, Href, SubTotal } from '../../../Utils/Constants'
import SvgIcon from '../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons'
import { dynamicImage } from '../../../Utils';
import { cartHeaderData } from '../../../Data/HeaderData/RightHeaderData';
import { X } from 'react-feather';

export default function CartHeader() {
    return (
        <LI className="cart-nav onhover-dropdown">
            <div className="cart-box">
                <SvgIcon iconId='Bag' />
                <Badges color='secondary' pill>2 </Badges>
            </div>
            <div className="cart-dropdown onhover-show-div">
                <H4 className="f-18 mb-0 dropdown-title">{Cart}</H4>
                <UL className='simple-list py-0'>
                    {cartHeaderData.map((item) => (
                        <LI key={item.id}>
                            <div className="d-flex">
                                <Image className="img-fluid b-r-5 img-40" src={dynamicImage(`product_list/product-categories/${item.src}`)} alt="" />
                                <div className="flex-grow-1">
                                    <span>{item.name}</span>
                                    <H6>{'1 X $ 299.00'}</H6>
                                </div>
                                <div className="close-circle"><a href={Href}><X /></a></div>
                            </div>
                        </LI>
                    ))}
                    <LI className="total">
                        <H5 className="mb-0">{SubTotal}<span className="f-right">{'$299.00'}</span></H5>
                    </LI>
                    <LI>
                        <Link className="view-cart" to={`${process.env.PUBLIC_URL}/applications/ecommerce/cart`}>{ViewCart}</Link>
                        <Link className="view-checkout f-right" to={`${process.env.PUBLIC_URL}/applications/ecommerce/checkout`}>{Checkout}</Link>
                    </LI>
                </UL>
            </div>
        </LI>
    )
}